import React, { Component } from 'react';


class Publications extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        return ( 
            <div>
                
            </div>
         );
    }
}
 
export default Publications;